import { Map } from 'immutable';

import Account from '../entity/Account';
import User from '../entity/User';

class IntercomService {
  private getIntercom: () => any;
  private appId: string;
  private isBooted: boolean;

  constructor(getIntercom: () => any, appId: string) {
    this.getIntercom = getIntercom;
    this.appId = appId;
    this.isBooted = false;
  }

  public identify = (user: User) => {
    this.bootOrUpdate({
      app_id: this.appId,
      user_id: user.id,
      name: user.name,
      email: user.email,
      id_user_lang: user.lang, // intercom custom field
    });
  };

  public anonymize = () => {
    this.getIntercom()('shutdown');
  };

  public hide = () => {
    this.getIntercom()('update', {
      hide_default_launcher: true,
    });
  };

  public show = () => {
    this.getIntercom()('update', {
      hide_default_launcher: false,
    });
  };

  private bootOrUpdate = (...args: any[]) => {
    this.getIntercom()(this.isBooted ? 'update' : 'boot', ...args);
    this.isBooted = true;
  };

  public updateByAccount = (user: User, account: Account) => {
    let argData = Map({
      app_id: this.appId,
      user_id: user.id,
      questionnaire_business_account_name: account.companyName,
      questionnaire_business_account_id: account.id,
    });

    if (account.questionnaireAnswer) {
      const qaList = JSON.parse(account.questionnaireAnswer).questionnaire_answer;
      qaList.forEach((qa: any) => {
        // intercomのfieldのkey文字列にスペース・一部の記号は渡せないためreplaceする
        // https://www.intercom.com/help/en/articles/179-send-custom-user-attributes-to-intercom#how-do-i-do-it
        const q = qa.question.replace(/[\s\.$~`!@#%^&*'{}|\\'"]/gi, '_'); // eslint-disable-line no-useless-escape
        argData = argData.set(q, qa.answer);
      });
    }

    this.bootOrUpdate(argData.toObject());
  };
}

export default IntercomService;
